export default __webpack_public_path__ + "static/media/04.b33700dc.jpg";